// import { useDeepCompareEffect } from '@oscar/utils';
import { useDeepCompareEffect } from '@oscar/utils';
import { FC, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMetadataSelector } from '../../selectors';
import { MetadataView, TableOptions } from '../../typed';

const ActionButton: FC<MetadataView> = ({ children, table }) => {
  const [options, setOptions] = useState<TableOptions>();

  useDeepCompareEffect(() => {
    if (table?.options) {
      setOptions(table?.options);
    }
  }, [table?.options]);

  const getMetadata = useMemo(() => {
    if (options) {
      const { name, keyField, reducerName } = options;
      return getMetadataSelector(name, keyField, reducerName);
    }
    return undefined;
  }, [options?.name, options?.keyField, options?.reducerName]);

  const metadata = useSelector((state: never) =>
    getMetadata ? getMetadata(state) : {}
  );

  return typeof children === 'function'
    ? children({
        table,
        metadata,
      })
    : null;
};

export default ActionButton;
